(function () {
  if (window.fgUpsellLoaded) return;
  window.fgUpsellLoaded = true;

  var BOARDS = ['abdominal-board', 'lumbar-board'];
  var BRA = ['recovery-bust-band'];
  var CARE = ['garment-detergent'];
  var cache = {};

  function pj(h) {
    if (!cache[h]) {
      cache[h] = fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[h];
  }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function img(u) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }

  var css = '.fgu{margin:14px 0 6px;border:1.5px solid #F8D6EB;border-radius:20px;padding:14px;background:#FDEEF6}' +
    '.fgu__h{margin:0 0 10px;font-weight:800;font-size:15px;color:#171717}' +
    '.fgu__list{display:flex;flex-direction:column;gap:10px}' +
    '.fgu__item{display:flex;align-items:center;gap:10px;background:#fff;border-radius:16px;padding:8px}' +
    '.fgu__img{flex:0 0 54px;height:54px;border-radius:12px;overflow:hidden;background:#FDEEF6;display:block}' +
    '.fgu__img img{width:100%;height:100%;object-fit:cover;display:block;mix-blend-mode:multiply}' +
    '.fgu__info{flex:1;min-width:0;display:flex;flex-direction:column;gap:2px}' +
    '.fgu__t{font-weight:700;font-size:14px;color:#171717;text-decoration:none;line-height:1.25}' +
    '.fgu__p{font-size:13px;color:#5C5C5C}' +
    '.fgu__sel{margin-top:3px;font:inherit;font-size:12px;border:1px solid #F3A6D3;border-radius:999px;padding:3px 8px;max-width:100%;background:#fff;color:#171717}' +
    '.fgu__btn{flex:0 0 auto;min-height:38px;border-radius:999px;border:1.5px solid #CF2C8F;background:#fff;color:#B1297D;font:inherit;font-weight:700;font-size:13px;padding:0 14px;cursor:pointer}' +
    '.fgu__btn:hover{background:#FDEEF6}.fgu__btn[disabled]{opacity:.6}' +
    '.fgu-on .cart-item-upsells{display:none !important}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var busy = false, again = false;
  function schedule() { if (busy) { again = true; return; } run(); }

  function target() {
    var drawer = document.querySelector('cart-drawer');
    var root = drawer || document.querySelector('.cart-items, main');
    if (!root) return null;
    var list = root.querySelector('.cart-item-list');
    return list ? { root: drawer || document.body, list: list, isDrawer: !!drawer } : null;
  }

  function run() {
    busy = true;
    var t = target();
    if (!t) { busy = false; return; }
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var old = t.root.querySelector('.fgu');
      if (!cart.items.length) { if (old) old.remove(); t.root.classList.remove('fgu-on'); return null; }
      var inCart = {}; cart.items.forEach(function (i) { inCart[i.handle] = 1; });
      return Promise.all(cart.items.map(function (i) { return pj(i.handle); })).then(function (prods) {
        var post = false, bra = false, garment = false;
        prods.forEach(function (p) {
          if (!p) return;
          var tags = (p.tags || []).map(function (x) { return String(x).toLowerCase(); });
          var type = String(p.type || '').toLowerCase();
          var isPost = tags.indexOf('post surgical') > -1 || tags.indexOf('post-op recovery') > -1;
          if (type === 'bra') { garment = true; if (isPost) bra = true; }
          else if (type === 'shapewear') { garment = true; if (isPost) post = true; }
        });
        var hs = [];
        if (post) hs = hs.concat(BOARDS);
        if (bra) hs = hs.concat(BRA);
        if (garment) hs = hs.concat(CARE);
        hs = hs.filter(function (h, i) { return !inCart[h] && hs.indexOf(h) === i; }).slice(0, 3);
        if (!hs.length) { if (old) old.remove(); t.root.classList.remove('fgu-on'); return null; }
        return Promise.all(hs.map(pj)).then(function (cands) {
          cands = cands.filter(function (p) { return p && p.available; });
          if (!cands.length) { if (old) old.remove(); t.root.classList.remove('fgu-on'); return; }
          var html = '<p class="fgu__h">' + (post || bra ? 'Complete your recovery' : 'Keep your faja like new') + '</p><div class="fgu__list">';
          cands.forEach(function (p) {
            var avail = p.variants.filter(function (v) { return v.available; });
            var sel = '';
            if (avail.length > 1) {
              sel = '<select class="fgu__sel" aria-label="' + esc(p.title) + ' option">' + avail.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('') + '</select>';
            }
            html += '<div class="fgu__item"><a class="fgu__img" href="/products/' + p.handle + '">' + (p.featured_image ? '<img src="' + img(p.featured_image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
              '<div class="fgu__info"><a class="fgu__t" href="/products/' + p.handle + '">' + esc(p.title) + '</a><span class="fgu__p">' + money(p.price) + '</span>' + sel + '</div>' +
              '<button type="button" class="fgu__btn" data-id="' + avail[0].id + '" aria-label="Add ' + esc(p.title) + ' to cart">+ Add</button></div>';
          });
          html += '</div>';
          var box = old || document.createElement('div');
          box.className = 'fgu' + (t.isDrawer ? ' cart-drawer__content-item' : '');
          box.innerHTML = html;
          if (!old) t.list.insertAdjacentElement('afterend', box);
          t.root.classList.add('fgu-on');
        });
      });
    }).catch(function () {}).then(function () {
      busy = false;
      if (again) { again = false; run(); }
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('.fgu__btn') : null;
    if (!b) return;
    e.preventDefault();
    var item = b.closest('.fgu__item');
    var sel = item ? item.querySelector('.fgu__sel') : null;
    var id = sel ? sel.value : b.getAttribute('data-id');
    b.disabled = true; b.textContent = 'Adding...';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('fail'); return r.json(); })
      .then(function () {
        b.textContent = 'Added';
        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          try {
            var form = drawer.querySelector('cart-form');
            if (form && form.refresh) form.refresh(); else document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
          } catch (err) {}
          setTimeout(schedule, 900);
        } else {
          window.location.reload();
        }
      })
      .catch(function () { b.disabled = false; b.textContent = 'Try again'; });
  });

  function hook() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && !drawer.getAttribute('data-fgu')) {
      drawer.setAttribute('data-fgu', '1');
      drawer.addEventListener('on:cart-drawer:before-open', schedule);
      drawer.addEventListener('on:cart:after-merge', function () { setTimeout(schedule, 50); });
    }
    if (!drawer && document.querySelector('.cart-item-list')) schedule();
  }
  document.addEventListener('on:cart:after-merge', function () { setTimeout(schedule, 50); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hook); else hook();
})();
